// MessageBar intent types for v9 compatibility
type MessageIntent = "success" | "error" | "info" | "warning";

export const Styles = {
  getBackgroundColor: (type: MessageIntent): string => {
    switch (type) {
      case "success":
        return "#27b671";
      case "error":
        return "#dc3545";
      case "info":
        return "#82b8fa";
      case "warning":
        return "#f49a31";
      default:
        return "transparent";
    }
  },

  getNotifStyles: (type: MessageIntent) => ({
    root: {
      "zIndex": 300,
      "backgroundColor": Styles.getBackgroundColor(type),
      "padding": "2px 0px",
      "boxShadow": "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
      ".ms-MessageBar-content": {
        ".ms-MessageBar-text": {
          fontSize: "14px !important",
          fontWeight: "500 !important",
          color: "#050505",
        },

        ".ms-MessageBar-icon": {
          i: {
            color: "#050505 !important",
          },
        },
      },
    },
  }),

  notificationContainer: {
    position: "fixed" as const,
    top: 0,
    left: 0,
    right: 0,
    zIndex: 999999,
    pointerEvents: "none" as const,
  },
};
